<!-- START HEADER-->
<header class="header" app-case-header></header>
<!-- END HEADER-->

<!-- START SIDEBAR-->
<nav class="page-sidebar" id="sidebar" app-case-sidebar></nav>
<!-- END SIDEBAR-->

<!-- START PAGE CONTENT-->
<div class="content-wrapper">
    <router-outlet></router-outlet>
    <!-- <div app-banner></div> -->
    <footer class="page-footer" app-case-footer></footer>
</div>

